// extracted by mini-css-extract-plugin
export default {"address-type-item":"ShippingAddress_address-type-item__esz1G","active":"ShippingAddress_active__F6CY2"};